import { render, staticRenderFns } from "./MessageDispatchPanel.vue?vue&type=template&id=505503b4&scoped=true"
import script from "./MessageDispatchPanel.vue?vue&type=script&lang=js"
export * from "./MessageDispatchPanel.vue?vue&type=script&lang=js"
import style0 from "./MessageDispatchPanel.vue?vue&type=style&index=0&id=505503b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505503b4",
  null
  
)

export default component.exports